import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { btnCancel, btnOne, inputStyleTwo, label, title } from "../utils/style";
import { useRecoilValue } from "recoil";
import appointmentDetailsAtom from "../atoms/appointmentDetailsAtom";

function WorkOrderModal({ setShowModal, updateWorkOrderData, modalState, allServices }) {
    const [formData, setFormData] = useState({ hst: false, discount: 0, discountType: 'flat' })
    const [options, setOptions] = useState([]);
    const appointmentDetails = useRecoilValue(appointmentDetailsAtom);
    const [modalTitle, setModalTitle] = useState('')
    const defaultTaxCost = appointmentDetails.taxRatePercent

    useEffect(() => {
        switch (modalState) {
            case 'serviceBundle':
                setModalTitle('Service Bundle')
                setOptions(allServices.serviceBundle)
                break;

            case 'service':
                setModalTitle('Service')
                setOptions(allServices.serviceList)
                break;

            case 'material':
                setModalTitle('Part')
                setOptions(allServices.materialList)
                break;

            case 'other':
                setModalTitle('Other')
                setOptions(allServices.otherList)
                break;

            default:
                break;
        }
    }, [modalState])

    function updateData(e) {
        const { name, value, checked } = e.target;
        if (value === 'select') {
            return
        }
        const data = { ...formData };
        if (name === 'hst') {
            data[name] = checked
        } else if (name === 'name') {
            let newValue = JSON.parse(value);
           
            data.name = newValue.name;
            data.currency = newValue.currency
            if (modalState === 'serviceBundle') {
                data.services = newValue.services
                data.cost = newValue.cost;
            } else if (modalState === 'service' || modalState === 'other') {
                data.costType = newValue.costType
                data.estimatedTime = newValue.estimatedTime
                data.estimatedCost = newValue.estimatedCost
            } else if (modalState === 'material' || modalState === 'serviceBundle') {
                data.cost = newValue.cost;
                data.costType = newValue.costType
                data.estimatedTime = newValue.estimatedTime
            } else {
                data.estimatedTime = newValue.estimatedTime
            }

        } else {
            data[name] = value
        }
      
        setFormData(data);
    }

    function add() {
        if (!formData.name) {
            return toast.error('Please fill all the fields', { autoClose: 3000 });
        }

        if (formData.discount < 0) {
            return toast.error('Discount cannot be negative', { autoClose: 3000 });
        }

        if (formData.discountType === "flat") {
            const maxAllowed = formData.estimatedCost || formData.cost || 0;
            if (formData.discount > maxAllowed) {
                return toast.error(`Discount cannot be greater than ${maxAllowed}`, { autoClose: 3000 });
            }
        }

        if (formData.discountType === "percent" && formData.discount > 100) {
            return toast.error('Discount percent cannot exceed 100%', { autoClose: 3000 });
        }

        updateWorkOrderData(formData);
        setShowModal(null);
    }



    return (
        <div className="flex justify-center items-center bg-black p-8 fixed top-0 left-0 h-screen w-screen bg-opacity-50 z-30">
            <div className="px-6 py-8 bg-white rounded-xl w-full">
                <div className={title}>{modalTitle}</div>
                <div className="flex flex-col py-2">
                    <label className={label}>{`${modalTitle} Name`}</label>
                    <select name="name" onChange={e => updateData(e)} className={inputStyleTwo}>
                        {!formData.name && <option value={'select'}>--Select Name--</option>}
                        {
                            options?.map((option, ind) => <option key={ind} value={JSON.stringify(option)}>{option.name}</option>)
                        }
                    </select>
                    {
                        (modalState === 'material' || modalState === 'serviceBundle') &&
                        <div className="flex flex-col">
                            <label className={label}>Cost</label>
                            <input name="cost" type="number" value={formData.cost ? formData.cost : ''} disabled className={inputStyleTwo} />
                        </div>
                    }
                    {
                        (modalState !== 'serviceBundle') &&
                        <>
                            <label className={label}>{modalState === 'service' ? (formData.costType === 'Fixed' ? 'Estimated Cost' : 'Estimated Time') : 'Estimated Time'}</label>
                            <input
                                name={modalState === 'service' ? (formData.costType === 'Fixed' ? "estimatedCost" : "estimatedTime") : "estimatedTime"}
                                type="text"
                                value={formData.estimatedTime || formData.estimatedCost}
                                disabled
                                className={inputStyleTwo}
                            />
                        </>
                    }
                    {/* <label className={label}>Currency</label>
                    <input name="currency" type="text" value={formData.currency} disabled className={inputStyleTwo}/> */}
                    {(modalState === 'serviceBundle') || (modalState === 'material') || (modalState === 'service' && !formData.estimatedTime) ?
                        <div className="flex gap-4">
                            <div className="flex flex-col flex-1">
                                <label className={label}>Discount {formData.discountType === "flat" ? "(in $)" : "(in %)"}</label>
                                <input name="discount" type="number" value={formData.discount} className={inputStyleTwo}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        const clean = val === '' ? '' : Math.max(0, Number(val));
                                        updateData({ target: { name: 'discount', value: clean } });
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === '-' || e.key === '+' || e.key === 'e') {
                                            e.preventDefault();
                                        }
                                    }}
                                    onWheel={(e) => {
                                        e.target.blur();
                                    }}
                                />
                            </div>
                            <div className="flex flex-col flex-1">
                                <label className={label}>Type</label>
                                <select name="discountType" className={inputStyleTwo} onChange={e => updateData(e)}>
                                    <option value={'flat'}>Flat</option>
                                    <option value={'percent'}>Percent</option>
                                </select>
                            </div>
                        </div>
                        : null
                    }

                    {
                        modalState === 'material' &&
                        <div className="flex items-center">
                            <label className={label}>Sales Tax : <span className="font-light">{defaultTaxCost}%</span></label>
                            {/* <input name="hst" checked={formData.hst} type="checkbox" onChange={e => updateData(e)}  className={'ml-4'}/> */}
                        </div>
                    }
                </div>
                <div className="flex gap-4 py-2">
                    <button className={btnCancel} onClick={() => setShowModal(false)}>Cancel</button>
                    <button className={btnOne} onClick={() => add()}>Add</button>
                </div>
            </div>
        </div>
    )
}

export default WorkOrderModal;